"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateUser = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useUpdateUser(id) {
    const { data, isLoading, error, put } = (0, core_ui_1.useApiPut)(`users/${id}`);
    return { updatedUser: data, isUpdating: isLoading, error, updateUser: put };
}
exports.useUpdateUser = useUpdateUser;
//# sourceMappingURL=useUpdateUser.js.map